var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClassifycleanup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "96.000000pt",
    height: "96.000000pt",
    viewBox: "0 0 96.000000 96.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,96.000000) scale(0.100000,-0.100000)",
    fill: "currentColor",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M386 864 c-9 -8 -16 -24 -16 -35 0 -17 -8 -19 -83 -19 -51 0 -88 -5 -95 -12 -17 -17 -17 -689 0 -706 17 -17 559 -17 576 0 17 17 17 689 0 706 -7 7 -44 12 -95 12 -75 0 -83 2 -83 19 0 39 -26 51 -110 51 -58 0 -83 -4 -94 -16z m182 -41 c2 -25 8 -33 23 -33 16 0 19 -7 19 -40 l0 -40 -130 0 -130 0 0 40 c0 33 3 40 20 40 15 0 20 7 20 28 0 16 3 32 7 36 4 4 43 5 88 4 l80 -3 3 -32z m-238 -83 l0 -50 150 0 150 0 0 50 0 51 63 -3 62 -3 0 -340 0 -340 -275 0 -275 0 -3 330 c-1 181 0 336 3 342 3 9 25 13 65 13 l60 0 0 -50z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454 816 c-11 -29 0 -51 26 -51 21 0 25 5 25 30 0 24 -5 31 -23 33 -13 2 -24 -3 -28 -12z m36 -21 c0 -8 -4 -15 -10 -15 -5 0 -10 7 -10 15 0 8 5 15 10 15 6 0 10 -7 10 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623 588 c-27 -27 -34 -30 -48 -18 -25 21 -31 2 -7 -23 l22 -22 47 48 c28 28 42 47 33 47 -9 0 -30 -14 -47 -32z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280 580 c0 -6 42 -10 105 -10 63 0 105 4 105 10 0 6 -42 10 -105 10 -63 0 -105 -4 -105 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623 468 c-27 -27 -34 -30 -48 -18 -24 20 -28 6 -5 -15 21 -19 22 -18 63 23 23 23 37 42 32 42 -6 0 -25 -14 -42 -32z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280 460 c0 -6 42 -10 105 -10 63 0 105 4 105 10 0 6 -42 10 -105 10 -63 0 -105 -4 -105 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595 360 c17 -19 17 -21 0 -40 -20 -23 -14 -26 15 -8 15 10 22 10 32 0 20 -20 32 -13 13 8 -17 19 -17 21 0 40 21 23 14 26 -16 8 -17 -10 -23 -10 -26 0 -3 6 -12 12 -20 12 -14 0 -14 -3 2 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280 340 c0 -6 42 -10 105 -10 63 0 105 4 105 10 0 6 -42 10 -105 10 -63 0 -105 -4 -105 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595 240 c17 -19 17 -21 0 -40 -20 -23 -14 -26 15 -8 15 10 22 10 32 0 20 -20 32 -13 13 8 -17 19 -17 21 0 40 19 21 7 28 -13 8 -10 -10 -17 -10 -32 0 -29 18 -35 15 -15 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280 220 c0 -6 42 -10 105 -10 63 0 105 4 105 10 0 6 -42 10 -105 10 -63 0 -105 -4 -105 -10z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClassifycleanup);
export default __webpack_public_path__ + "static/media/classifycleanup.0a742673f2f04636020321dc13c5bec2.svg";
export { ForwardRef as ReactComponent };